import axios from 'axios'
import store from '../../store'

export class BaseApiClient {
  static axios () {
    return axios.create({
      baseUrl: process.env.VUE_APP_API_URL
    })
  }

  static getUrl (path, base = false) {
    const baseUrl = base ? process.env.VUE_APP_API_BASE_URL : process.env.VUE_APP_API_URL

    return `${baseUrl}/${path}`
  }

  static getAccessToken () {
    return store.state.accessToken
  }

  static getRefreshToken () {
    return store.state.refreshToken
  }

  static getBearerToken () {
    return `Bearer ${this.getAccessToken()}`
  }

  static getAuthHeaders () {
    return {
      Authorization: this.getBearerToken()
    }
  }

  static async refreshToken () {
    const refreshTokenResponse = await this.axios()
      .post(this.getUrl('auth/refresh-token'), {
        refresh_token: this.getRefreshToken()
      })

    const refreshTokenData = refreshTokenResponse.data

    if (refreshTokenData.status !== 'success') {
      return false
    }

    store.dispatch('authorize', refreshTokenData.data)

    return true
  }

  static async shouldRedoRequest (responseStatus, config) {
    return config && config.headers &&
      config.headers.Authorization &&
      responseStatus === 401 &&
      this.getRefreshToken() &&
      (await this.refreshToken())
  }

  static async backendLogin () {
    return this.axios()
      .get(this.getUrl(`auth?access-token=${this.getAccessToken()}`, true), {
        withCredentials: true
      })
  }

  static async backendLogout () {
    return this.axios()
      .get(this.getUrl(`auth/logout?access-token=${this.getAccessToken()}`, true), {
        withCredentials: true
      })
  }

  static async get (url, config, refreshedToken = false) {
    return this.axios()
      .get(this.getUrl(url), config)
      .catch(async error => {
        let response = error.response
        if (await this.shouldRedoRequest(response.status, config, refreshedToken)) {
          config.headers.Authorization = this.getBearerToken()
          response = await this.axios()
            .get(this.getUrl(url), config)
        }

        return response
      })
  }

  static async post (url, data, config) {
    return this.axios()
      .post(this.getUrl(url), data, config)
      .catch(async error => {
        let response = error.response
        if (await this.shouldRedoRequest(error.response.status, config)) {
          config.headers.Authorization = this.getBearerToken()
          response = await this.axios()
            .post(this.getUrl(url), data, config)
        }

        return response
      })
  }

  static async put (url, data, config) {
    return this.axios()
      .put(this.getUrl(url), data, config)
      .catch(async error => {
        let response = error.response
        if (await this.shouldRedoRequest(error.response.status, config)) {
          config.headers.Authorization = this.getBearerToken()
          response = await this.axios()
            .put(this.getUrl(url), data, config)
        }

        return response
      })
  }

  static async delete (url, config) {
    return this.axios()
      .delete(this.getUrl(url), config)
      .catch(async error => {
        let response = error.response
        if (await this.shouldRedoRequest(error.response.status, config)) {
          config.headers.Authorization = this.getBearerToken()
          response = await this.axios().delete(this.getUrl(url), config)
        }

        return response
      })
  }

  static async patch (url, data, config) {
    return this.axios()
      .patch(this.getUrl(url), data, config)
      .catch(async error => {
        let response = error.response
        if (await this.shouldRedoRequest(error.response.status, config)) {
          config.headers.Authorization = this.getBearerToken()
          response = await this.axios().patch(this.getUrl(url), data, config)
        }

        return response
      })
  }
}
